import { render, staticRenderFns } from "./MatchSignupEntrySection.vue?vue&type=template&id=1ac9a234&scoped=true"
import script from "./MatchSignupEntrySection.vue?vue&type=script&lang=js"
export * from "./MatchSignupEntrySection.vue?vue&type=script&lang=js"
import style0 from "./MatchSignupEntrySection.vue?vue&type=style&index=0&id=1ac9a234&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac9a234",
  null
  
)

export default component.exports